var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPredictions = function SvgPredictions(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 27 31"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.4,
    d: "M17.357 0H7.714a1.931 1.931 0 0 0-1.928 1.938c0 1.071.862 1.937 1.928 1.937v8.04c0 .715-.199 1.423-.572 2.029L.62 24.594A4.24 4.24 0 0 0 0 26.798C0 29.117 1.874 31 4.183 31h18.634C25.126 31 27 29.117 27 26.798c0-.775-.217-1.538-.62-2.204L19.857 13.95a3.893 3.893 0 0 1-.572-2.028V3.875a1.931 1.931 0 0 0 1.928-1.938A1.931 1.931 0 0 0 19.286 0zm-6.29 13.856V4h4.866v9.856a9.35 9.35 0 0 0 1.444 4.98L23 27H5l4.623-8.164a9.35 9.35 0 0 0 1.444-4.98"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.067 13.856h4.866a9.35 9.35 0 0 0 1.444 4.98L23 27H5l4.623-8.164a9.35 9.35 0 0 0 1.444-4.98"
  }))));
};
export default SvgPredictions;